import { render, staticRenderFns } from "./dialogEditProfile_REMOTE_1935.vue?vue&type=template&id=179bbf3a&scoped=true"
import script from "./dialogEditProfile_REMOTE_1935.vue?vue&type=script&lang=ts"
export * from "./dialogEditProfile_REMOTE_1935.vue?vue&type=script&lang=ts"
import style0 from "./dialogEditProfile_REMOTE_1935.vue?vue&type=style&index=0&id=179bbf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179bbf3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VRow,VTextField})
